<template>
    <CondicionesReportTable :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable" @downloadExcel="downloadExcel">
        <span slot="after-filters">
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="downloadExcel" flat>
              <v-icon color="primary">far fa-file-excel</v-icon>
            </v-btn>
            <span>Descargar XLS</span>
          </v-tooltip>
        </span>
    </CondicionesReportTable>
</template>

<script>
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'
import CondicionesReportTable from './CondicionesReportTable.vue'

export default {
  mixins: [downloadFileMixin, paginationMixin],
  data () {
    return {
      path: `condiciones/cuerpo-tecnico/list`,
      filterPath: 'filter/condiciones'
    }
  },
  components: {
    CondicionesReportTable
  },
  computed: {
    headers () {
      return [
        { text: 'Club', value: 'club', align: 'left', filterField: true, sortable: false },
        { text: 'Mes', value: 'mes', align: 'left', sortable: false },
        { text: 'Apellido', value: 'playerLastName', align: 'left', sortable: false },
        { text: 'Nombre', value: 'playerFirstName', align: 'left', sortable: false },
        { text: 'Concepto', value: 'concepto', align: 'left', sortable: false },
        { text: 'Bruto/Neto', value: 'brutoNeto', align: 'left', sortable: false },
        { text: 'Frecuencia', value: 'frecuencia', align: 'left', sortable: false },
        { text: 'Moneda', value: 'moneda', align: 'left', sortable: false },
        { text: 'Tipo de Cambio', value: 'tipoDeCambio', align: 'left', sortable: false },
        { text: 'Desc. Tipo de Cambio', value: 'tipoDeCambioDescripcion', align: 'left', sortable: false },
        { text: 'Importe', value: 'importeMensual', align: 'left', sortable: false, currencyField: true },
        { text: 'Cuota', value: 'cuota', align: 'left', sortable: false },
        { text: 'Temporada', value: 'temporada', align: 'left', sortable: false }

      ]
    },
    properties () {
      return ['club', 'mes', 'playerLastName', 'playerFirstName', 'concepto', 'brutoNeto', 'frecuencia', 'moneda', 'tipoDeCambio', 'tipoDeCambioDescripcion', 'importeMensual', 'cuota', 'temporada']
    }
  },
  methods: {
    getExcelPath () {
      return 'condiciones/cuerpo-tecnico/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'condiciones_cuerpo_tecnico'
    }
  }
}
</script>
